module.exports = __webpack_public_path__ + "img/stock1.7ecdf0d3.png";